module.exports = __webpack_public_path__ + "europa-5_hologram.jpg?5471fd9ba9c4cc0d364b6c0f0a425ca2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_hologram.jpg
// module id = 388
// module chunks = 0